module.exports = __webpack_public_path__ + "img/educationalStages.b623ac90.svg";